<div class="container-fluid">
  <p class="signup__sub-head-text">Pick one of our FarmBoxes</p>
  <div class="row mt-5">
    @defer (when subscriptionCard().length) {
    @if (subscriptionCard())
    {
    @for (product of subscriptionCard(); track product.id) {
    @defer (on viewport; prefetch on immediate) {
    <div class="col-xl-4 col-lg-4 col-12 animated fadeIn mb-3" (mouseenter)="onProductCardHover.emit(product.id)">
      <div class="product-card-grid__item">
        @let productDetails = this.productDetails().get(product.id);
        <app-product-card-v2 class="product-card__box"
          [cardResume]="{settings: {}, product, productDetails:  productDetails}" [isSignupFlow]="true"
          [subscribeAndcustomizeBox]="true" [class.selected]="selectedCard === product" [isFromShop]="!!productDetails"
          (onComponentReady)="outComponentReady.emit(product.id)"
          (farmBoxCard)="selectedFarmBox($event, product)"></app-product-card-v2>
      </div>
    </div>
    } @placeholder {
    <div class="col-xl-4 col-lg-4 col animated fadeInUp fadeIn mb-3">
      <div class="card position-relative border p-3 row-gap-3" aria-hidden="true">
        <span class="placeholder bg-secondary col-12"></span>
        <span class="placeholder bg-secondary col-6"></span>
        <div class="placeholder bg-secondary col-12" style="height: 100px"></div>
        <div class="card-body">
          <h5 class="card-title placeholder-glow">
            <span class="placeholder bg-secondary col-6"></span>
          </h5>
          <p class="card-text placeholder-glow">
            <span class="placeholder bg-secondary col-7"></span>
            <span class="placeholder bg-secondary col-4"></span>
            <span class="placeholder bg-secondary col-4"></span>
            <span class="placeholder bg-secondary col-6"></span>
            <span class="placeholder bg-secondary col-8"></span>
          </p>
        </div>
      </div>
    </div>
    } }
    }
    } @placeholder (minimum 1s) {
    <div class="loader-container">
      <div class="loader">
        @for (item of [0,0,0,0,0]; track $index) {
        <div class="bg-secondary"></div>
        }
      </div>
    </div>
    }
  </div>
</div>
